export default __webpack_public_path__ + "/static/media/no-ship.20aee545.jpg";